/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";

export type DeleteRemoteSessionClientSecurityOption1 = {
  projectSlugHeaderGramProject: string;
  sessionHeaderGramSession: string;
};

export type DeleteRemoteSessionClientSecurityOption2 = {
  apikeyHeaderGramKey: string;
  projectSlugHeaderGramProject: string;
};

export type DeleteRemoteSessionClientSecurity = {
  option1?: DeleteRemoteSessionClientSecurityOption1 | undefined;
  option2?: DeleteRemoteSessionClientSecurityOption2 | undefined;
};

export type DeleteRemoteSessionClientRequest = {
  /**
   * The remote_session_client id.
   */
  id: string;
  /**
   * Session header
   */
  gramSession?: string | undefined;
  /**
   * API Key header
   */
  gramKey?: string | undefined;
  /**
   * project header
   */
  gramProject?: string | undefined;
};

/** @internal */
export type DeleteRemoteSessionClientSecurityOption1$Outbound = {
  "project_slug_header_Gram-Project": string;
  "session_header_Gram-Session": string;
};

/** @internal */
export const DeleteRemoteSessionClientSecurityOption1$outboundSchema:
  z.ZodMiniType<
    DeleteRemoteSessionClientSecurityOption1$Outbound,
    DeleteRemoteSessionClientSecurityOption1
  > = z.pipe(
    z.object({
      projectSlugHeaderGramProject: z.string(),
      sessionHeaderGramSession: z.string(),
    }),
    z.transform((v) => {
      return remap$(v, {
        projectSlugHeaderGramProject: "project_slug_header_Gram-Project",
        sessionHeaderGramSession: "session_header_Gram-Session",
      });
    }),
  );

export function deleteRemoteSessionClientSecurityOption1ToJSON(
  deleteRemoteSessionClientSecurityOption1:
    DeleteRemoteSessionClientSecurityOption1,
): string {
  return JSON.stringify(
    DeleteRemoteSessionClientSecurityOption1$outboundSchema.parse(
      deleteRemoteSessionClientSecurityOption1,
    ),
  );
}

/** @internal */
export type DeleteRemoteSessionClientSecurityOption2$Outbound = {
  "apikey_header_Gram-Key": string;
  "project_slug_header_Gram-Project": string;
};

/** @internal */
export const DeleteRemoteSessionClientSecurityOption2$outboundSchema:
  z.ZodMiniType<
    DeleteRemoteSessionClientSecurityOption2$Outbound,
    DeleteRemoteSessionClientSecurityOption2
  > = z.pipe(
    z.object({
      apikeyHeaderGramKey: z.string(),
      projectSlugHeaderGramProject: z.string(),
    }),
    z.transform((v) => {
      return remap$(v, {
        apikeyHeaderGramKey: "apikey_header_Gram-Key",
        projectSlugHeaderGramProject: "project_slug_header_Gram-Project",
      });
    }),
  );

export function deleteRemoteSessionClientSecurityOption2ToJSON(
  deleteRemoteSessionClientSecurityOption2:
    DeleteRemoteSessionClientSecurityOption2,
): string {
  return JSON.stringify(
    DeleteRemoteSessionClientSecurityOption2$outboundSchema.parse(
      deleteRemoteSessionClientSecurityOption2,
    ),
  );
}

/** @internal */
export type DeleteRemoteSessionClientSecurity$Outbound = {
  Option1?: DeleteRemoteSessionClientSecurityOption1$Outbound | undefined;
  Option2?: DeleteRemoteSessionClientSecurityOption2$Outbound | undefined;
};

/** @internal */
export const DeleteRemoteSessionClientSecurity$outboundSchema: z.ZodMiniType<
  DeleteRemoteSessionClientSecurity$Outbound,
  DeleteRemoteSessionClientSecurity
> = z.pipe(
  z.object({
    option1: z.optional(
      z.lazy(() => DeleteRemoteSessionClientSecurityOption1$outboundSchema),
    ),
    option2: z.optional(
      z.lazy(() => DeleteRemoteSessionClientSecurityOption2$outboundSchema),
    ),
  }),
  z.transform((v) => {
    return remap$(v, {
      option1: "Option1",
      option2: "Option2",
    });
  }),
);

export function deleteRemoteSessionClientSecurityToJSON(
  deleteRemoteSessionClientSecurity: DeleteRemoteSessionClientSecurity,
): string {
  return JSON.stringify(
    DeleteRemoteSessionClientSecurity$outboundSchema.parse(
      deleteRemoteSessionClientSecurity,
    ),
  );
}

/** @internal */
export type DeleteRemoteSessionClientRequest$Outbound = {
  id: string;
  "Gram-Session"?: string | undefined;
  "Gram-Key"?: string | undefined;
  "Gram-Project"?: string | undefined;
};

/** @internal */
export const DeleteRemoteSessionClientRequest$outboundSchema: z.ZodMiniType<
  DeleteRemoteSessionClientRequest$Outbound,
  DeleteRemoteSessionClientRequest
> = z.pipe(
  z.object({
    id: z.string(),
    gramSession: z.optional(z.string()),
    gramKey: z.optional(z.string()),
    gramProject: z.optional(z.string()),
  }),
  z.transform((v) => {
    return remap$(v, {
      gramSession: "Gram-Session",
      gramKey: "Gram-Key",
      gramProject: "Gram-Project",
    });
  }),
);

export function deleteRemoteSessionClientRequestToJSON(
  deleteRemoteSessionClientRequest: DeleteRemoteSessionClientRequest,
): string {
  return JSON.stringify(
    DeleteRemoteSessionClientRequest$outboundSchema.parse(
      deleteRemoteSessionClientRequest,
    ),
  );
}
